export * from 'server/models/PSixVesselResult';


// WEBPACK FOOTER //
// ./data/models/PSixVesselResult.ts